module.exports = __webpack_public_path__ + "img/2.80f0f7cf.jpg";